module.exports = new __parcel__URL__("Fundraising.0b5ad295.svg").toString();